import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

/**
 * @param {string} projectId
 * @returns {Promise<Record<string, unknown> | null>}
 */
export async function fetchProjectDoc(projectId) {
  if (!projectId) return null;
  const snap = await getDoc(doc(db, 'projects', projectId));
  if (!snap.exists()) return null;
  return { id: snap.id, ...snap.data() };
}
